// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_px-0";
export var animationContainer = "_px-1";
export var itemPrice = "_px-a";
export var itemizedContent = "_px-9";
export var itemizedHeader = "_px-7";
export var itemizedRow = "_px-8";
export var itemizedSection = "_px-6";
export var modalContent = "_px-2";
export var orderName = "_px-3";
export var refundOption = "_px-4";
export var refundOptionsContainer = "_px-5";
export var shippingLabel = "_px-b";
export var totalRow = "_px-c";